import axios from "axios";

export const basicUrl = `https://py.qubx3d.com/api/v1`;

const instance = axios.create({
  baseURL: "https://py.qubx3d.com/api/v1",
});

instance.interceptors.request.use((config) => {
  return config;
});
export const httpNonToken = instance;

export const endPoints = {
  login: "/login", //Login - auth
  requestStatus: "/status", // get all status
  qubxOperator: "/employeeProfile", // get all qubx operator
  sms: "/sms/template", //get all SMS
  governorate: "/governorates", //get all governorates
  region: "/regions", //get all governorates
  diconSource: "/diconSource",

  //Request
  request: "/request", //get all request tracking
  updateRequest: "/request/update", //update request Data

  //patient
  patients: "/patient", // get all patients
  createPatient: "/patient/create",
  updatePatient: "/patient/update",

  //doctor
  doctors: "/doctorProfile", // get all doctor
  createDoctor: "/user/doctor-rc/create",
  updateDoctor: "/doctorProfile/update",

  //Printing Provider
  printing: "/printing", //get all Printing Provider
  createPrinting: "/printing/create",
  updatePrinting: "/printing/update",
  requestPrinting: "/request/printing",
  createRequestPrinting: "/request/printing/create",
  updateRequestPrinting: "/request/printing/update",

  //courier
  courier: "/courier", //get all Courier Branches
  createCourier: "/courier/create",
  updateCourier: "/courier/update",
  requestCourier: "/request/courier",
  createRequestCourier: "/request/courier/create",
  updateRequestCourier: "/request/courier/update",

  //Branch
  rcBranch: "/branch", //get all RC Branches
  createRcBranch: "/branch/user/create",
  updateRcBranch: "/branch/update",
  rcGroup: "/rcGroup",

  //Notes
  notes: "/note",
  createNote: "/note/create",

  //   notifications
  notifications: "/notifications",
  updateNotification: "/notifications/update",
  updateGroupNotifications: "/notifications/read",

  // send Msg
  sendMsg: "/sms/send",

  // stl file
  stl: "/request/stl",
  updateStl: "/request/stl/reupload",

  // Sirv
  sirv: "/sirv/upload-file",
  deleteSirve: "/sirv/delete-folder-content",

  // get sirv url
  getSirvUrl: "/sirv/get-url-spin",

  // create branch
  createBranch: "branch/user/create",
  getBranch: "branch/",
  updateBranch: "/branch/update",

  // user
  updateUser: "/user/update",
  getUser: "/user",

  getRequestByCode: "/request/code",
};
